
import { useState, useEffect } from "react";
import BASE_URL from "../BASEURL";
import Navbar from "../components/Navbar";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";

export default function Gallery() {
    const [gallery, setGallery] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchGallery = async () => {
            setLoading(true);
            setError("");
            try {
                const res = await fetch(`${BASE_URL}/api/gallery`);
                if (!res.ok) throw new Error("Failed to fetch gallery");
                const json = await res.json();
                const raw = Array.isArray(json.data) ? json.data : [];
                // sort by `index` (ascending). Items without index go to the end.
                raw.sort((a, b) => {
                    const ia = typeof a.index === 'number' ? a.index : Infinity;
                    const ib = typeof b.index === 'number' ? b.index : Infinity;
                    return ia - ib;
                });
                setGallery(raw);
            } catch (err) {
                setError(err.message || "Failed to fetch gallery");
            } finally {
                setLoading(false);
            }
        };
        fetchGallery();
    }, []);

    return (
        <>
            <Navbar />
            <div className='bg-dark'>
                <Breadcrumb />
            </div>
            {/* GALLERY SECTION */}
            <section className="py-10 bg-white">
                <div className="max-w-7xl mx-auto px-6">
                    {/* HEADING */}
                    <div className="text-center mb-14" data-aos="fade-up">
                        <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary">
                            Water & Wastewater Treatment Project Gallery
                        </h1>
                        <p className="mt-4 text-gray-600 font-body max-w-3xl mx-auto">
                            Browse our project gallery featuring successfully executed water and
                            wastewater treatment installations, including ETP, STP and WTP plants,
                            sludge dewatering systems, industrial blowers and acoustic enclosures
                            delivered by Sera Water across Ahmedabad and Gujarat.
                        </p>
                    </div>

                    {loading && <p className="p-10">Loading...</p>}
                    {error && <p className="p-10 text-red-500">{error}</p>}

                    {/* GALLERY GRID */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {gallery.length === 0 && !loading && <p className="p-10">No images found.</p>}
                        {gallery.map((item, index) => (
                            <div
                                key={item.id || item._id || item.title}
                                data-aos="zoom-in"
                                data-aos-delay={index * 100}
                                className="group relative overflow-hidden rounded-xl shadow-sm hover:shadow-xl transition"
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-full h-64 object-contain group-hover:scale-105 transition duration-500"
                                />
                                {/* OVERLAY */}
                                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                                    <h3 className="text-white font-heading font-semibold text-lg text-center px-4">
                                        {item.title}
                                    </h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
